'use client';

import { Box } from '@coolblue-development/freddy';
import { SalesPrice, SalesPriceCurrent } from '@coolblue-development/next-sales-price/client';
import { InsuranceProduct } from '@features/product/typings';
import useTestId from '@hooks/useTestId';
import { useTranslation } from '@i18n/useTranslation';

export default function InsuranceProductPrice({
  product,
  size
}: {
  product: InsuranceProduct;
  size?: 'small' | 'medium' | 'large';
}) {
  const { t } = useTranslation('webshop');
  const testId = useTestId('insurance-product-price');

  const paymentTypeKey =
    product.paymentType === 'one-time'
      ? 'productPage.insurance.oneTimePayment'
      : 'productPage.insurance.monthly';

  return (
    <Box {...testId}>
      <SalesPrice
        size={size}
        currentPrice={
          <SalesPriceCurrent price={product.premium.includingVat} suffix={t(paymentTypeKey)} />
        }
      />
    </Box>
  );
}
